import { PermissionsContext } from 'context/PermissionsContext';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_DISTRIBUTOR = 'ROLE_DISTRIBUTOR';
export const ROLE_CLIENT = 'ROLE_CLIENT';

/**
 * 
 * @param {*} blockPermissions 
 * @param {*} pemissionsList 
 * @returns boolean
 */
export const setMoreOpsDisabled = (blockPermissions, userPerms) => {
  if (!userPerms?.mainProfile) return;
  let { isSuper, permissions } = userPerms.mainProfile;
  if (isSuper) return true;
  return permissions.some(perm => blockPermissions.find(el => el === perm));
};

/**
 * 
 * @param {*} blockPermission
 * @param {*} userPerms
 * @returns boolean
 */
export const permissionHandler = (blockPermission, userPerms, isPageLevel) => {
console.log("🚀 ~ file: index.js ~ line 29 ~ permissionHandler ~ blockPermission", blockPermission)
  if (!userPerms) return;
  let { mainProfile, fallbackProfile } = userPerms;
  if (mainProfile.isSuper || fallbackProfile?.isSuper) return true;
  let permissions = fallbackProfile ? [...mainProfile.permissions, fallbackProfile.permissions] : mainProfile.permissions;
  if (!permissions) return;
  return isPageLevel
  ?
  permissions.some(perm => blockPermission.find(el => el === perm))
  :
  !!permissions.find(permission => permission === blockPermission);
};

/**
 * 
 * @param {*} blockPermissions 
 * @param {*} userPerms 
 * @returns boolean
 */
export const sidebarPermissionHandler = (blockPermissions = [], userPerms) => {
  if (!userPerms) return;
  // if (!blockPermissions || !blockPermissions.length) return true;
  let { isSuper, permissions } = userPerms;
  if (isSuper) return true;
  return permissions.some(permission => blockPermissions.find(blockPerm => blockPerm === permission));
};

export const PermissionRenderElements = ({
  children,
  blockPermission
}) => {

  const { userPermissions } = useContext(PermissionsContext);
  const [isPermitted, setPermitted] = useState(false);

  useEffect(() => {
    setPermitted(permissionHandler(blockPermission, userPermissions));
  }, [blockPermission, userPermissions]);

  useEffect(() => {
    console.log("isPermitted", isPermitted);
  }, [isPermitted])

  return isPermitted ? <>{children}</> : false;
}

PermissionRenderElements.propTypes = {
  blockPermission: PropTypes.object.isRequired,
};